import { memo, useEffect } from "react";
import { ProjectDetailProps } from "@/type/ProjectTypes";
import { DateUtils } from "@/utils/dateUtil";
import { cn } from "@/lib/utils";
import imgUrlMapper from "@/utils/imgUrl-mapping";
import { useNavigate } from "react-router-dom";

const ProjectListItem: React.FC<{
  project: Omit<ProjectDetailProps, "project_pin">;
  className?: string;
  open?: boolean;
  idx: number;
  isActive?: boolean;
  onOpenChange?: (open: boolean) => void;
}> = ({ project, className, open, onOpenChange }) => {
  const nav = useNavigate();

  const {
    title,
    thumbnail,
    description,
    start_date,
    end_date,
    id,
    project_member,
    project_meta_stack,
  } = project;

  const stack = project_meta_stack.flatMap((e) => e.project_stack);
  const frameWork = stack.find(
    (e) =>
      e.type === "framework" && (e.stack === "React" || e.stack === "Next.js")
  );

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (hash === id.toString() && !open) onOpenChange?.(true);
      else if (hash !== id.toString() && open) onOpenChange?.(false);
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [id, open, onOpenChange]);

  return (
    <div
      onClick={() => nav(`/work/${id}`)}
      tabIndex={0}
      className={cn(
        // [!!] 1. 전체적인 패딩을 줄여 컴팩트하게 만듭니다.
        "group relative cursor-pointer flex flex-col gap-3 ",
        "transition-all duration-500 hover:opacity-95 group",
        className
      )}
    >
      <div className="flex flex-col justify-center gap-2 mb-10">
        {" "}
        <div
          className="lg:block hidden relative aspect-5/3 grayscale-70 hover:grayscale-0 transition-all rounded-sm bg-cover bg-center mb-3  "
          style={{
            backgroundImage: `url(${thumbnail ? imgUrlMapper({ thumbnail }) : ""})`,
          }}
        ></div>
        <h3 className="text-xl group-hover:underline flex items-center gap-5 font-semibold tracking-tight text-zinc-50 leading-tight line-clamp-2">
          <span>{title}</span>
        </h3>{" "}
        <div className="flex items-center gap-4 text-sm text-zinc-500 mt-1">
          {/* text-[0.85rem] -> text-xs, mt-1 추가 */}
          <span className="whitespace-nowrap">{project_member}</span>
          <span className="opacity-40">•</span>
          <span className="text-zinc-500">
            {DateUtils.getDurationDays(start_date!, end_date!)}일
          </span>

          {frameWork && (
            <>
              <span className="opacity-40">•</span>
              <span className="text-pink-400">{frameWork.stack}</span>
            </>
          )}
        </div>
        <p className=" mb-3 text-sm max-w-[800px] mt-2 text-zinc-300 leading-relaxed opacity-80 line-clamp-2  break-keep ">
          {description}
        </p>
      </div>
    </div>
  );
};

export default memo(ProjectListItem);
